<template>
  <div class="pagination-box" :class="{isFew: total <= 1}">
    <div class="pagination" v-if="total > 1">
      <div class="icon" v-if="page > 0">
        <svg
          @click="$emit('change-page', page - 1)"
          v-if="page > 0"
          class="deactive"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
        >
          <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
          <path d="M0 0h24v24H0z" fill="none" />
        </svg>
      </div>

      <p @click="$emit('change-page', page - 1)" v-if="page > 0">{{page}}</p>
      <p class="active">{{page + 1}}</p>
      <p @click="$emit('change-page', page + 1)" v-if="page < total - 1">{{page + 2}}</p>
      <p @click="$emit('change-page', page + 2)" v-if="page < total - 2">{{page + 3}}</p>

      <div v-if="page < total - 2" class="icon">

        <svg
          @click="$emit('change-page', page + 1)"
          class="deactive"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"

        >
          <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
          <path d="M0 0h24v24H0z" fill="none" />
        </svg>
      </div>
    </div>
    <div
        class="text_Page_margin"
      v-if="qnt"
      :class="{showing: qnt}"
    >{{ `Showing ${qnt ? (page * perPage + 1) : 0} to ${(page * perPage) + +qnt} of ${Math.round(total*perPage)} entries` }}</div>
  </div>
</template>

<script>
export default {
  props: ["page", "total", "perPage", "qnt"],
};
</script>

<style lang="scss" scoped>

.pagination-box.isFew {
  justify-content: flex-end;
}
.pagination-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-top: 20px;
}
.pagination {
  display: flex;
  align-items: center;
  color: #212b36;
  font-family: "Helvetica Neue";
  svg {
    fill: #212b36;
    cursor: pointer;
  }
  p {
    background-color: #fff;
    margin-bottom: 0px;
    padding: 5px 12px;
    border-radius: 0px;
    cursor: pointer;
    border: 2px solid #f8f9fe;
  }
  .deactive {
    // color: #bdbfd8;
    // fill: #bdbfd8;
  }
  .active {
    background-color: #51a3f3;
    color: #fff;
  }
  .icon {
    background-color: #fff;
    padding: 5px 12px;
  }
}
@media (min-width: 474px) {
  .text_Page_margin{
  margin-left: 30px;
  }
}
</style>

